import React from 'react';
import PropTypes from 'prop-types';

import { ProducerTeaser } from '/components/producer-teaser/components';

import '/components/map/styles/map-marker.scss';

const MapMarker = ({ title, onClick, theme, producer, active }) => (
    <div className="map-marker-wrapper">
        <button className={`map-marker ${active ? 'is-active' : ''}`} onClick={onClick}>
            <span className="visually-hidden">{title}</span>
            <svg className="" viewBox="0 0 24 24">
                <use xlinkHref="#icon-marker" />
            </svg>
        </button>
        {active && (
            <div className="map-marker-teaser">
                <ProducerTeaser producer={producer} />
                <button
                    className="map-marker-teaser__close"
                    onClick={() => { window.setActiveHit(null); }}
                >
                    <svg viewBox="0 0 30 30">
                        <use xlinkHref="#icon-close" />
                    </svg>
                </button>
            </div>
        )}
    </div>
);

MapMarker.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    theme: PropTypes.string,
};

MapMarker.defaultProps = {
    onClick: '',
    theme: 'red',
};

export { MapMarker };
